import { render, staticRenderFns } from "./Beneficiarios.vue?vue&type=template&id=6902e348"
import script from "./Beneficiarios.vue?vue&type=script&lang=js"
export * from "./Beneficiarios.vue?vue&type=script&lang=js"
import style0 from "./Beneficiarios.vue?vue&type=style&index=0&id=6902e348&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports